module.exports = __webpack_public_path__ + "img/plus.e0c79e98.svg";